import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { SalesforceMarketingCloudObjectDataset } from 'app/model/dataset/salesforce-marketing-cloud-object.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from 'app/model/adapters/datasets/tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceMarketingCloudObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class SalesforceMarketingCloudDatasetAdapter extends TabularTypeDatasetAdapter<SalesforceMarketingCloudObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SalesforceMarketingCloudObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(SalesforceMarketingCloudObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SalesforceMarketingCloudObjectDataset): Promise<SalesforceMarketingCloudObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, SalesforceMarketingCloudObjectDataset.MODEL);
    }
}
